module.exports = __webpack_public_path__ + "media/icons/game-icon-b37a5a2b.svg";